import React from 'react';

const Spinner = () => {
  return (
    <div className="flex items-center justify-center fixed inset-0 bg-gray-100 bg-opacity-50 z-50">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-solid"></div>
    </div>
  );
};

export default Spinner;
